import script from "./ProjectOffered.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectOffered.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectOffered.vue?vue&type=style&index=0&id=1a27b482&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a27b482"]])

export default __exports__